import {AppliedDiscount, AppliedDiscountDiscountType} from '@wix/auto_sdk_ecom_current-cart';
import {AppliedCouponModel} from '../models/AppliedCoupon.model';

export const toAppliedCouponSDK = (appliedDiscounts: AppliedDiscount[]) => {
  const appliedCoupon = appliedDiscounts?.find((discount) => discount.coupon);
  const discountType = appliedCoupon?.discountType;
  return appliedCoupon ? AppliedCouponModel.fromSDK(appliedCoupon.coupon, discountType) : undefined;
};

export const isFreeShippingCoupon = (coupon?: AppliedCouponModel): boolean =>
  coupon?.discountType === AppliedDiscountDiscountType.SHIPPING;
